export enum AggregatedOrderProductCombineStatus {
    NORMAL,
    PARENT,
    CHILD,
}

export interface AggregatedOrderProduct {
    /**
     * 复合业务主键（不可变标识）
     * 生成规则：店铺ID列表 + uniqProductKey拼接
     */
    id: string;
    /**
     * 商品数量
     * 计算逻辑：
     * - 普通商品/子商品：相同uniqProductKey数量累加
     * - 组合商品：根据子商品的quantity进行数量累加
     */
    quantity: number;
    skuProperties?: string;
    title: string;
    picture?: string;
    simpleTitle?: string;
    shopId?: number;

    /** 商品信息排序用字段 */
    sortInfo?: AggregatedOrderProductSortInfo;

    /** 是否为组合商品 */
    combineStatus: AggregatedOrderProductCombineStatus;

    /**
     * 子商品
     * 重要规则：父子商品必须保持mergedKey一致
     */
    childProducts?: AggregatedOrderProduct[];

    /**
     * 商品合并依据键
     */
    mergedKey: string;

    /**
     * 同一店铺下商品唯一识别标识
     *
     * 生成规则：
     * - 普通商品/子商品：通过buildOrderItemTag生成（包含标题/属性/原始ID）
     * - 父级组合商品：取所有子商品uniqProductKey，用"+"连接
     *
     */
    uniqProductKey: string;

    /**
     * 商品关联的店铺ID列表
     */
    shopIds?: number[];

    /**
     * 该商品对应的订单信息
     */
    orderIds: number[];

    /**
     * 该商品对应的商品项信息
     * 规则:同一个AggregatedOrderProduct中的所有orderItem都是相同的
     */
    orderItemIds: number[];
}

export interface AggregatedOrderProductSortInfo {
    productExternalId?: string;
    productOriginalId?: string;
    title?: string;
    localSkuProperties?: string;
    skuProperties?: string;
    skuExternalId?: string;
    skuOriginalId?: string;
}
